import React, { useEffect, useState } from 'react';
import { Form, Button, Tag } from 'antd';
import { CheckCircleOutlined, EditOutlined, FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import '../SurveyAnswer.less';
import { uploadFileApi } from '../../api';
import config from '../../../../config';
import SignaturePad from 'signature_pad';
import dayjs from 'dayjs';

let signaturePad: any = null;

/*
 * false - 屏幕锁定时，页面全屏
 * true - 屏幕关闭锁定时，浏览器全屏
 */
let fullScreenType = false;

// 电子签名
const Signature: React.FC = ({ body, id, required, optionList, num, form }: { body?: string; required?: boolean; num?: number; id?: number; optionList?: any; form?: any }) => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [saveId, setSaveId] = useState<number>();
    const [imageUrl, setImageUrl] = useState();
    const [disabled, setDisabled] = useState(true);

    // 是否点击此处签名
    const [showCanvas, setShowCanvas] = useState(false);

    // 横竖屏状态
    const [orientation, setOrientation] = useState('portrait');

    // 重新签名
    const onReSign = () => {
        signaturePad.clear();
        form.setFieldValue(`${id}-12`, undefined);
        localStorage.setItem('initFormData', JSON.stringify(form.getFieldsValue()));
        setSaveId(0);
        setImageUrl(undefined);
        setDisabled(true);
        resizeCanvas();
    };

    // 生成随机uuid
    const guid = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };

    // 上传文件路径 - 前缀
    const getFileUrl = (url: string) => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return `${config.OSS_URL_PREFIX}/${url}`;
        }
        return null;
    };

    // base64转image
    const convertBase64ToFile = async (base64String: string, type?: boolean) => {
        // 去除Base64字符串中的数据类型和编码前缀
        const base64Data = atob(base64String.split(',')[1]);
        const arrayBuffer = new ArrayBuffer(base64Data.length);
        const uint8Array = new Uint8Array(arrayBuffer);
        // 将Base64数据逐字节转换为Uint8Array
        for (let i = 0; i < base64Data.length; i++) {
            uint8Array[i] = base64Data.charCodeAt(i);
        }
        // 创建Blob对象
        const blob = new File([uint8Array], guid + '.png', { type: 'application/octet-stream' });

        let formData = new FormData();
        formData.append('file', blob);
        formData.append('path', `attachments/${dayjs().format('YYYYMM')}/`);
        const res: any = await uploadFileApi(formData);
        if (res.status_code === 200 && res.data) {
            form.setFieldValue(`${id}-12`, [`${getFileUrl(res.data)}`]);
            localStorage.setItem('initFormData', JSON.stringify(form.getFieldsValue()));

            if (!type) {
                console.log(fullScreenType);
                if (fullScreenType) {
                    console.log(base64String);
                    resizeCanvas();
                } else if (!fullScreenType && isFullScreen) {
                    rotateResizeCanvas();
                }
            }
        }
    };

    // 图片转base64
    const getBase64Image = (src: string) => {
        return new Promise(resolve => {
            let xhr = new XMLHttpRequest();
            xhr.open('get', src, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                if (this.status == 200) {
                    let blob = this.response;
                    let oFileReader = new FileReader();
                    oFileReader.onloadend = function (e: any) {
                        const base64 = e.target.result;
                        resolve(base64);
                    };
                    oFileReader.readAsDataURL(blob);
                }
            };
            xhr.send();
        });
    };

    // 保存签名
    const onSave = () => {
        //将图片另存为PNG
        const data = signaturePad.toDataURL();
        convertBase64ToFile(data);

        setSaveId(id);
        setImageUrl(data);
        signaturePad.clear();
        signaturePad.fromDataURL(data);

        setIsFullScreen(false);
    };

    // 全屏
    const onFullScreen = () => {
        setIsFullScreen(!isFullScreen);
        // signaturePad.off();
    };

    // 视口监听
    const resizeChange = (e: any) => {
        if (window.innerWidth > window.innerHeight) {
            fullScreenType = true;
            resizeCanvas();
        } else {
            fullScreenType = false;
            resizeCanvas();
        }
    };

    // 重绘canvas
    const resizeCanvas = () => {
        const canvas: any = document.querySelector('canvas');
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);
        const currentSign = form.getFieldValue(`${id}-12`);
        signaturePad.clear();
        if (currentSign && currentSign.length && currentSign[0]) {
            // signaturePad.fromDataURL(currentSign);
            getImageEcho(`${currentSign[0]}`);
        }
    };

    //签完名的图片旋转处理
    const rotateBase64Img = (src: string, edg: number, callback: any) => {
        let canvas: any = document.createElement('canvas');
        let ctx: any = canvas.getContext('2d');
        let imgW; //图片宽度
        let imgH; //图片高度
        let size; //canvas初始大小
        if (edg % 90 != 0) {
            console.error('旋转角度必须是90的倍数!');
            throw '旋转角度必须是90的倍数!';
        }
        edg < 0 && (edg = (edg % 360) + 360);
        const quadrant = (edg / 90) % 4; //旋转象限
        const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; //裁剪坐标
        var image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = src;
        image.onload = function () {
            imgW = image.width;
            imgH = image.height;
            size = imgW > imgH ? imgW : imgH;
            canvas.width = size * 2;
            canvas.height = size * 2;
            switch (quadrant) {
                case 0:
                    cutCoor.sx = size;
                    cutCoor.sy = size;
                    cutCoor.ex = size + imgW;
                    cutCoor.ey = size + imgH;
                    break;
                case 1:
                    cutCoor.sx = size - imgH;
                    cutCoor.sy = size;
                    cutCoor.ex = size;
                    cutCoor.ey = size + imgW;
                    break;
                case 2:
                    cutCoor.sx = size - imgW;
                    cutCoor.sy = size - imgH;
                    cutCoor.ex = size;
                    cutCoor.ey = size;
                    break;
                case 3:
                    cutCoor.sx = size;
                    cutCoor.sy = size - imgW;
                    cutCoor.ex = size + imgH;
                    cutCoor.ey = size + imgW;
                    break;
            }
            ctx.translate(size, size);
            ctx.rotate((edg * Math.PI) / 180);
            // drawImage向画布上绘制图片
            ctx.drawImage(image, 0, 0);
            // getImageData() 复制画布上指定矩形的像素数据
            var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
            if (quadrant % 2 == 0) {
                canvas.width = imgW;
                canvas.height = imgH;
            } else {
                canvas.width = imgH;
                canvas.height = imgW;
            }
            // putImageData() 将图像数据放回画布
            ctx.putImageData(imgData, 0, 0);
            callback(canvas.toDataURL());
        };
    };

    // 监听手机横屏
    const orientationChange = () => {
        resizeCanvas();
        if (window.orientation == 180 || window.orientation == 0) {
            setOrientation('portrait');
            console.log('竖屏');
        }
        if (window.orientation == 90 || window.orientation == -90) {
            setOrientation('landscape');
            resizeCanvas();
            console.log('横屏');
        }
    };

    // 假横屏切换至竖屏 - 旋转重绘新的base64
    const rotateResizeCanvas = async () => {
        const canvas: any = document.querySelector('canvas');
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);
        const currentSign = form.getFieldValue(`${id}-12`);
        if (currentSign && currentSign.length && currentSign[0]) {
            // getImageEcho(`${config.OSS_URL_PREFIX}/${currentSign[0]}`);
            // signaturePad.fromDataURL(currentSign);
            const base64: any = await getBase64Image(`${currentSign[0]}`);
            if (base64) {
                rotateBase64Img(base64, 270, function (base64data: any) {
                    //生成的base64内容
                    const base64 = base64data;
                    if (base64) {
                        signaturePad.clear();
                        signaturePad.fromDataURL(base64);

                        convertBase64ToFile(base64, true);
                    }
                });
            }
        }
    };

    // 绘图结束时 - 回调
    const onEnd = () => {
        console.log(false, 'disabled');
        setDisabled(false);
    };

    // 图片回显
    const getImageEcho = async (url: string) => {
        const base64: any = await getBase64Image(url);
        signaturePad.fromDataURL(base64);
    };

    useEffect(() => {
        const canvas: any = document.querySelector('canvas');
        signaturePad = new SignaturePad(canvas, { backgroundColor: '#F5F5F5', penColor: 'rgb(0, 0, 0)' });

        // 初始化设置画布内容
        // signaturePad.fromDataURL('');

        signaturePad.addEventListener('endStroke', onEnd);
        window.addEventListener('resize', resizeChange);
        window.addEventListener('orientationchange', orientationChange);

        return () => {
            signaturePad.removeEventListener('endStroke', onEnd);
            window.removeEventListener('resize', resizeChange);
            window.removeEventListener('orientationchange', orientationChange);
        };
    }, []);

    useEffect(() => {
        // if (!(!isFullScreen && fullScreenType)) {
        //     resizeCanvas();
        // }
        resizeCanvas();
    }, [isFullScreen]);

    // 接口回显 / 本地数据缓存
    useEffect(() => {
        if (optionList && optionList.length) {
            let answer = optionList[0].content ? JSON.parse(optionList[0].content) : '';
            if (answer) {
                setShowCanvas(true);
                setSaveId(id);
                setImageUrl(answer[0]);
                setDisabled(false);
                getImageEcho(`${answer[0]}`);
            }
        } else {
            const formData = form.getFieldValue(`${id}-12`);
            console.log(formData);
            if (formData) {
                if (formData && formData.length && formData[0]) {
                    setShowCanvas(true);
                    setSaveId(id);
                    setImageUrl(formData[0]);
                    setDisabled(false);
                    getImageEcho(formData);
                }
            }
        }
    }, [optionList]);

    return (
        <>
            <Form.Item name={[`${id}-12`, 0]} rules={[{ required, message: '该题为必答题，请作答后提交。' }]} label={<div className="label-flex" dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}>
                {isFullScreen ? (
                    <div className={`signature-topic_full`}>
                        {!showCanvas ? (
                            <div className="signature-mask" onClick={() => setShowCanvas(true)}>
                                请在此处签名
                                <EditOutlined />
                            </div>
                        ) : null}
                        <canvas className={`${!!imageUrl && 'canvas-disabled'}`}></canvas>
                        {window.innerWidth < 750 && (
                            <Button type="primary" ghost className="exit-btn" onClick={onFullScreen}>
                                <FullscreenExitOutlined />
                                退出
                            </Button>
                        )}
                        {showCanvas && (
                            <p className={`${orientation === 'portrait' ? 'signature-btn' : 'signature-btn_landscape'}`}>
                                {saveId === id && (
                                    <Tag className="sign-status" icon={<CheckCircleOutlined />} color="success">
                                        已保存
                                    </Tag>
                                )}
                                <span className="btn-right">
                                    {/* {window.innerWidth < 750 && <Button type="primary" ghost className="exit-btn" onClick={onFullScreen}><FullscreenExitOutlined />退出</Button>} */}
                                    <Button type="primary" ghost onClick={onReSign} disabled={disabled}>
                                        重新签名
                                    </Button>
                                    {saveId !== id && (
                                        <Button type="primary" disabled={disabled} onClick={onSave}>
                                            保存
                                        </Button>
                                    )}
                                </span>
                            </p>
                        )}
                    </div>
                ) : (
                    <div className={`signature-topic`}>
                        {!showCanvas ? (
                            <div className="signature-mask" onClick={() => setShowCanvas(true)}>
                                请在此处签名
                                <EditOutlined />
                            </div>
                        ) : null}
                        <canvas className={`${!!imageUrl && 'canvas-disabled'}`}></canvas>
                        {showCanvas && (
                            <p className="signature-btn">
                                {saveId === id ? (
                                    <Tag className="sign-status" icon={<CheckCircleOutlined />} color="success">
                                        已保存
                                    </Tag>
                                ) : (
                                    window.innerWidth > 750 && <span className="save-tip">完成签名后，请点击“保存”按钮</span>
                                )}
                                <span className="btn-right">
                                    {!imageUrl && window.innerWidth < 750 ? (
                                        <Button type="primary" className="full-btn" ghost onClick={onFullScreen}>
                                            <FullscreenOutlined />
                                            全屏
                                        </Button>
                                    ) : null}
                                    <Button type="primary" ghost onClick={onReSign} disabled={disabled}>
                                        重新签名
                                    </Button>
                                    {saveId !== id && (
                                        <Button type="primary" disabled={disabled} onClick={onSave}>
                                            保存
                                        </Button>
                                    )}
                                </span>
                            </p>
                        )}
                    </div>
                )}
            </Form.Item>
        </>
    );
};

export default Signature;
